import xsEcommerce from '../../../assets/Solutions/xsEcommerce.jpg';
import xsInstitucional from '../../../assets/Solutions/xsInstitucional.jpg';
import xsLandingPage from '../../../assets/Solutions/xsLandingPage.jpg';

export const SolutionsContent = [
    {
        key: 1,
        xsImage: xsLandingPage,
        title: 'Landing page',
        description: 'Página única, atrativa e otimizada para prospecção de leads e geração de novos clientes'
    },
    {
        key: 2,
        xsImage: xsInstitucional,
        title: 'Site Institucional',
        description: 'Seu cartão de visita online; um site para promover sua marca, seus produtos e seus serviços com informações relevantes sobre o seu negócio'
    },
    {
        key: 3,
        xsImage: xsEcommerce,
        title: 'E-Commerce',
        description: 'Uma loja virtual personalizada de fácil e segura navegação para seu negócio conquistar novos patamares'
    },
]